/**
 * Telegram `BackButton` ni ekranga bog'laydi — docs/TELEGRAM.md.
 *
 * `SPEC.md` §Navigatsiya: o'z orqaga tugmangiz FAQAT fokusli ekranlarda
 * (`create`, `shop`, `settings`, `dm`, `room`, `profile`). Dock bor
 * ekranlarda ikkalasi ham bo'lmaydi.
 *
 * Telegram tugmasi ham, ekrandagi tugma ham BITTA funksiyani chaqiradi —
 * aks holda ikkalasi ajralib ketadi va biri eskiradi.
 */

import { useEffect, useRef } from 'react';

import { supportsModernApi, tg } from './telegram';

export function useBackButton(enabled: boolean, onBack: () => void): void {
  // Ref orqali: `onBack` har renderda yangi funksiya bo'ladi va usiz
  // tugma har renderda qayta bog'lanardi.
  const handler = useRef(onBack);

  // Yangilash RENDER PAYTIDA emas, effektda: render toza bo'lishi kerak,
  // aks holda React'ning kelajakdagi bir necha marta render qilishida
  // ref eskirgan qiymat bilan qolib ketishi mumkin.
  useEffect(() => {
    handler.current = onBack;
  });

  useEffect(() => {
    // `BackButton` 6.1 dan boshlab bor. Eski klientda foydalanuvchi
    // qamalib qolmaydi — ekranda o'z orqaga tugmamiz bor.
    if (!supportsModernApi() || !tg) return;

    const button = tg.BackButton;
    if (!button || !enabled) return;

    const fire = (): void => handler.current();
    button.onClick(fire);
    button.show();

    return () => {
      button.offClick(fire);
      button.hide();
    };
  }, [enabled]);
}
